module.exports = __webpack_public_path__ + "media/Audio18_a.dab7a991.wav";